// extracted by mini-css-extract-plugin
export default {"timer":"timer_timer__9n-YJ","active":"timer_active__-Bdcy","divWrap":"timer_divWrap__O0+WW"};